(function() {

  function getModalSubscriptionManager() {

    var $subscriptionModalOverlay;
    var $subscriptionModalCloseButton;
    var DISMISSED_COOKIE = 'subscription-popup-dismissed';
    var SUBSCRIBER_COOKIE = 'is-subscriber';
    var HIDDEN_CLASS = 'is-hidden';


    function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    }

    function setCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + 24*60*60*1000*days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }

    function showSubscriptionModal() {
      $subscriptionModalOverlay.removeClass(HIDDEN_CLASS);
    }

    function dismissSubscriptionModal() {
      $subscriptionModalOverlay.addClass(HIDDEN_CLASS);
      setCookie(DISMISSED_COOKIE, true, 365);
    }

    function submitFormHandler() {
      setCookie(SUBSCRIBER_COOKIE, true, 28);
      return true;
    }

    function referenceElements() {
      $subscriptionModalOverlay = $('#js-subscription-modal-overlay');
      $subscriptionModalCloseButton = $('#js-subscription-modal-close-button');
    }

    function bindUIActions() {
      $subscriptionModalCloseButton.on('click', dismissSubscriptionModal);
      $('#popupSubForm, #inPageSubForm').on('submit', submitFormHandler);
    }

    function getHasSubscribedOrDismissed() {
      return getCookie(DISMISSED_COOKIE) || getCookie(SUBSCRIBER_COOKIE);
    }

    function startTimerUnlessSubscribedOrDismissed() {
      if (!getHasSubscribedOrDismissed()) {
        setTimeout(showSubscriptionModal, 10000);
      }
    }

    function init() {
      referenceElements();
      bindUIActions();
      startTimerUnlessSubscribedOrDismissed();
    }

    return {
      init: init,
    };

  }

  $(function() {
    var manager = getModalSubscriptionManager();
    manager.init();
  });

})();
